export const HARDCODED_CHAPTER_ID = "ch-01";

export const SESSION_STORAGE_KEY_LANGUAGE = "lang";
